import React, { useEffect, useState } from 'react';
import './Adds.css';

import FallbackNNLiveDesktop from '../../assets/NNLiveAds/ad-nnlive-desktop.png';
import FallbackNNLiveMobile from '../../assets/NNLiveAds/ad-nnlive-mobile.png';


const fallbackAd = {
  url: 'https://www.nakednews.com/',
  desktopBannerUrl: FallbackNNLiveDesktop,
  mobileBannerUrl: FallbackNNLiveMobile,
};

function VerticalAds(props) {
  const [ad, setAd] = useState(undefined);
  const { adData } = props;

  const getAd = () => {
    if (adData?.profileUrl || adData?.bannerImageDesktop) {
      const { profileUrl, bannerImageDesktop, bannerImageMobile } = adData;

      setAd({
        url: profileUrl,
        desktopBannerUrl: bannerImageDesktop,
        mobileBannerUrl: bannerImageMobile,
      });
    } else {
      setAd(fallbackAd);
    }
  };

  useEffect(() => {
    getAd();
  }, [adData]);

  return ad ? (
    <div className="vertical-ad-container">
      <div>
        <a className="desktop-ad" href={ad.url} rel="noreferrer" target="_blank" >
          <img alt="NakednewsLive-ad" src={ad.desktopBannerUrl} />
        </a>
        <a className="mobile-ad" href={ad.url} rel="noreferrer" target="_blank" >
          <img alt="NakednewsLive-ad" src={ad.mobileBannerUrl} />
        </a>
      </div>
    </div>
  ) : null;
}

export default VerticalAds;
